<!-- 代理商信息 -->
<template>
    <div v-if="componentsData.type == 20"
        :style="`
            padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px; background: ${componentsData.content.bg_color};
            border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;
        `"
    >
        <div>
            <div class="fw-bold" :style="`font-size: ${componentsData.content.title_size}px;color: ${componentsData.content.title_color};`">
                代理 ( 经销 ) 商名称
            </div>
            <div class="mt-5" :style="`font-size: ${componentsData.content.size}px;color: ${componentsData.content.text_color};`">
                <div class="mt-5" v-if="componentsData.content.type.includes('授权编号')">授权编号：123456</div>
                <div class="mt-5" v-if="componentsData.content.type.includes('手机号码')">手机号码：12345678912</div>
                <div class="mt-5 dis-flex" v-if="componentsData.content.type.includes('负责区域')">
                    <div>负责区域：</div>
                    <div class="w230">宁夏银川贺兰县、天津天津河东区、安徽安庆望江县、安徽安庆太湖县</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.fw-bold {
    font-weight: bold;
}
.mt-5 {
    margin: 5px 0 0 0;
}
.dis-flex {
    display: flex;
}
.w230 {
    width: 230px;
}
</style>